import { BaseApiRequest } from "@robe/core-api";
import { XcoreCore } from ".";
import { Inquiry } from "@robe/core-types/inquiry";
import { getInquiries } from "@robe/core-api/inquiries/getInquiries";
import { insertInquiry, InsertInquiryParams } from "@robe/core-api/inquiries";
import { getInquiry } from "@robe/core-api/inquiries/getInquiry";

export class XcoreInquiry {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  public getInquiry(id: number): BaseApiRequest<Inquiry> {
    return getInquiry(this.core, id);
  }

  public list(): BaseApiRequest<Inquiry[]> {
    return getInquiries(this.core);
  }

  public insert(params: InsertInquiryParams): BaseApiRequest<Inquiry> {
    return insertInquiry(this.core, params);
  }
}
